var darkmodeClass = 'body--dark-mode';
var darkmodeTrigger = document.querySelector('.js-toggle-dark-mode')
var darkmodeTarget = document.querySelector('body');

function fiets_darkmode(status = false, setCookie = true) {
    if (true === status) {
        darkmodeTarget.classList.add(darkmodeClass);
    } else {
        darkmodeTarget.classList.remove(darkmodeClass);
    }

    if (setCookie) {
        //Add cookie
        document.cookie = 'darkmode=' + String(!status) + '; expires=Fri, 31 Dec 1999 23:59:59 GMT; path=/';
        document.cookie = 'darkmode=' + String(status) + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    }
}

function checkDarkmode() {
    //If darkmode=true exists
    if (document.cookie.indexOf('darkmode=true') > -1) {
        fiets_darkmode(true);
    }
}

//On load, check if dark mode is enabled
document.addEventListener('DOMContentLoaded', checkDarkmode);

//On click on trigger, toggle mode
darkmodeTrigger.onclick = function () {
    if (false === darkmodeTarget.classList.contains(darkmodeClass)) {
        fiets_darkmode(true);
    } else {
        fiets_darkmode(false);
    }
};

//**** BROWSER COLOR MODE ****//
// check if matchMedia is supported
if (window.matchMedia) {
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    //If the color mode of the browser is dark, activate dark mode
    if (query.matches && -1 === document.cookie.indexOf('darkmode=')) {
        fiets_darkmode(true, false);
    }

    let eventQueryChecker = function (e) {
        // matches query -> dark mode activated
        if (e.matches) {
            fiets_darkmode(false, false);
        } else {
            fiets_darkmode(true, false);
        }
    };

    //If the color mode of the browser changes, activate the right mode
    try {
        query.addEventListener('change', (e) => {
            eventQueryChecker(e);
        });
    } catch (exceptionEventListener) {
        try {
            // Fallback for older versions of Safari
            query.addListener((e) => {
                eventQueryChecker(e);
            });
        } catch (exceptionListener) {
        }
    }
}